<iss-form-field [showNecessity]="showNecessity">
  <iss-label>Country</iss-label>
  <wo-country-input
    [formControl]="control.control"
    [readonly]="readonly"
    [role]="role"
    [countries]="countries"
  />
  <ng-template issFormFieldError let-errors>
    <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
  </ng-template>
</iss-form-field>
